function isMobileDevice() {
  const agentReg = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
  return agentReg && screenWidth <= 768
}

class CompleteLook extends HTMLElement {
  constructor() {
    super()

    this.addEventListener('click', (event) => {
      function toggleOpenStatus(target) {
        if (!target) return
        if (target.hasAttribute('open')) {
          target.setAttribute('close', '')
          setTimeout(() => {
            target.removeAttribute('open')
            target.removeAttribute('close')
          }, 350)
          target.parentNode?.removeAttribute('open')
        } else {
          target.setAttribute('open', '')
          target.parentNode?.setAttribute('open', '')
        }
      }

      const targetItemInner = event.target.closest('.sm-complete-look__item-inner')
      if (targetItemInner) {
        const targetItem = targetItemInner.parentNode
        if (isMobileDevice()) {
          const popupId = targetItem.dataset.popupId
          const pupup = document.getElementById(popupId)
          if (pupup && !pupup.closest('complete-look')) {
            pupup.setAttribute('open', '')
          }
        } else {
          const items = targetItem.parentNode.querySelectorAll('.sm-complete-look__item')
          items.forEach((item) => {
            if (item.hasAttribute('open') && item !== targetItem) {
              item.removeAttribute('open')
            }
          })
          toggleOpenStatus(targetItem)
        }
        this.pixelHandler(targetItem)
      }
      const close = event.target.closest('.sm-complete-look__popup-close')
      if (close) {
        toggleOpenStatus(close.closest('.sm-complete-look__item'))
        close.closest('.sm-complete-look__list')?.removeAttribute('open')
      }
    })

    const swiperEl = this.querySelector('.swiper-container')
    function setMultipleItemClassList(swiper) {
      const slides = Array.from(swiper.slides)
      const activeSildeIndex = slides.findIndex((slide) => slide.classList.contains('swiper-slide-active'))
      slides.forEach((slide, index) => {
        if (index === activeSildeIndex + (swiper.params.slidesPerView - 1)) {
          slide.classList.add('is-multiple')
        } else {
          slide.classList.remove('is-multiple')
        }
      })
    }

    if (swiperEl && Swiper) {
      new Swiper(swiperEl, {
        slidesPerView: 4,
        spaceBetween: 16,
        nextButton: this.querySelector('.sm-swiper__btn--next'),
        prevButton: this.querySelector('.sm-swiper__btn--prev'),
        breakpoints: {
          1024: {
            slidesPerView: 3
          },
          480: {
            slidesPerView: 1.4
          }
        },
        onInit(swiper) {
          setMultipleItemClassList(swiper)
        },
        onSlideChangeStart(swiper) {
          setMultipleItemClassList(swiper)
        }
      })
    }
  }

  pixelHandler(element) {
    const { lookHandle } = element.dataset
    const products = window.completeLookProducts[lookHandle]
    const coreGoogleGtag = window.CORE_GOOGLEGTAG
    const listKey = 'bundle_' + lookHandle
    if (coreGoogleGtag) {
      coreGoogleGtag._hanldeEventViewItemList({
        itemsKey: lookHandle,
        listId: listKey,
        listName: listKey,
        items: products
      })
    }
  }
}
customElements.define('complete-look', CompleteLook)

class CompleteLookPopup extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('click', (event) => {
      const div = event.target.closest('div')
      const close = event.target.closest('.sm-complete-look__popup-close')
      if (!div || close) {
        this.setAttribute('close', '')
        setTimeout(() => {
          this.removeAttribute('open')
          this.removeAttribute('close')
        }, 350)
      }

      const productEl = event.target.closest('.sm-complete-look__products-inner')
      if (productEl) {
        event.preventDefault()
        const { lookHandle, productVendor } = productEl.dataset
        const moduleGtag = window.MOUDLE_GTAG
        const items = moduleGtag.refinedItems[lookHandle]
        const product = items.find(item => item.item_category5 == productVendor)
        gtag('event', 'select_item', {
          button_name: 'complete_the_look',
          items: [product]
        })
        window.location.href = productEl.getAttribute('href')
      }
    })
  }

  connectedCallback() {
    if (isMobileDevice()) {
      if (this.moved) return
      this.moved = true
      document.body.appendChild(this)
    }
  }
}
customElements.define('complete-look-popup', CompleteLookPopup)
